import React from "react";
import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import {Button, DropdownMenuItem} from "@reside/ui";

import {getResidentTestId} from "../../helper";
import {createPreflightUrl} from "../../../../pages/page-admin-preflight/route";
import {AdmissionFromSearch} from "../../../../services/AdmissionsService";
import {AppState, select} from "../../../../store";

const useEditPreflightAdmission = (admission: AdmissionFromSearch) => {
  const isResideAdmin = useSelector((state: AppState) =>
    select.adminSession.isResideAdmin(state),
  );
  const history = useHistory();
  const disabled = isResideAdmin;
  const onEdit = () => {
    if (disabled) {
      return;
    }
    history.push(
      createPreflightUrl({
        facilityId: admission.facilityId,
        admissionId: admission.id,
      }),
    );
  };
  const testId = getResidentTestId(admission, "editPccPreflight");
  return {disabled, onEdit, testId};
};

export const EditPreflightDropdownItem = ({
  admission,
}: {
  admission: AdmissionFromSearch;
}) => {
  const {disabled, onEdit, testId} = useEditPreflightAdmission(admission);

  return (
    <DropdownMenuItem disabled={disabled} onClick={onEdit} testId={testId}>
      Edit
    </DropdownMenuItem>
  );
};

export const EditPreflightFooterButton = ({
  admission,
}: {
  admission: AdmissionFromSearch;
}) => {
  const {disabled, onEdit, testId} = useEditPreflightAdmission(admission);

  return (
    <Button
      size="small"
      color="primary"
      outline
      flat
      disabled={disabled}
      onClick={onEdit}
      testId={testId}
    >
      Edit
    </Button>
  );
};
